import React, { useEffect } from 'react';
import usePrevious from '../../../helpers/usePrevious';
import type { SearchAction } from '../SpotlightState';

type Options = {
	isNLSSearchOn: boolean;
	dispatch: React.Dispatch<SearchAction>;
};

export function useResetOnSearchModeChange({ isNLSSearchOn, dispatch }: Options) {
	const previousIsNLSSearchOn = usePrevious(isNLSSearchOn);

	useEffect(() => {
		// Toggling invalidates the other mode's results either way: plain NLS returns no dropdown
		// results at all, and hybrid ranks them differently because it is a different endpoint.
		// Reset back to the shell's default (idle) state on either transition.
		if (previousIsNLSSearchOn === undefined || previousIsNLSSearchOn === isNLSSearchOn) {
			return;
		}

		dispatch({ type: 'modeReset' });
	}, [isNLSSearchOn, previousIsNLSSearchOn, dispatch]);
}
